module.exports = __webpack_public_path__ + "img/chevron.fc6aafa4.svg";